import { render, staticRenderFns } from "./deliverySuccess.vue?vue&type=template&id=cecdc8c8&scoped=true"
import script from "./deliverySuccess.vue?vue&type=script&lang=js"
export * from "./deliverySuccess.vue?vue&type=script&lang=js"
import style0 from "./deliverySuccess.vue?vue&type=style&index=0&id=cecdc8c8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecdc8c8",
  null
  
)

export default component.exports